<div class="language-switcher">
  <div class="language-toggle">
    @for (lang of languageService.languages; track lang.code) {
      <button
        class="lang-button"
        [class.active]="languageService.isLanguageActive(lang.code)"
        (click)="switchLanguage(lang.code)"
        [attr.aria-label]="'Switch to ' + lang.name"
      >
        <span class="flag">{{ lang.flag }}</span>
        <span class="lang-code">{{ lang.code.toUpperCase() }}</span>
      </button>
    }
  </div>
</div>
